import {connect} from 'react-redux';
import classNames from 'classnames';

import Legend from './Legend';
import Toggle from './Toggle';

const Area = ({show}) => [
    <Toggle key="toggle" show={show} />,
    <div key="container" className={classNames('container', {show})}>
        <Legend />
    </div>
];

const mapStateToProps = ({showProductLegend: show}) => ({show});

export default connect(mapStateToProps)(Area);
